<style>
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
button,
textarea,
p,
blockquote,
th,
td,
hr {
    margin: 0;
    padding: 0
}

/* body {
    line-height: 1.333;
    font-size: 12px
} */

h1,
h2,
h3,
h4,
h5,
h6 {
    font-size: 100%;
    font-family: arial, 'hiragino sans gb', 'microsoft yahei', 'Simsun', sans-serif
}

input,
textarea,
select,
button {
    font-size: 12px;
    font-weight: normal
}

input[type="button"],
input[type="submit"],
select,
button {
    cursor: pointer
}

table {
    border-collapse: collapse;
    border-spacing: 0
}

address,
caption,
cite,
code,
dfn,
em,
th,
var {
    font-style: normal;
    font-weight: normal
}

li {
    list-style: none
}

caption,
th {
    text-align: left
}

q:before,
q:after {
    content: ''
}

abbr,
acronym {
    border: 0;
    font-variant: normal
}

sup {
    vertical-align: text-top
}

sub {
    vertical-align: text-bottom
}

fieldset,
img,
a img,
iframe {
    border-width: 0;
    border-style: none
}

img {
    -ms-interpolation-mode: bicubic
}

textarea {
    overflow-y: auto
}

legend {
    color: #000
}

a:link,
a:visited {
    text-decoration: none
}

hr {
    height: 0
}

label {
    cursor: pointer
}

.clearfix:after {
    content: "\200B";
    display: block;
    height: 0;
    clear: both
}

.clearfix {
    *zoom: 1
}

a {
    color: #328CE5
}

a:hover {
    color: #2b8ae8;
    text-decoration: none
}

a.hit {
    color: #C06C6C
}

a:focus {
    outline: none
}

.hit {
    color: #8DC27E
}

.txt_auxiliary {
    color: #A2A2A2
}

.clear {
    *zoom: 1
}

.clear:before,
.clear:after {
    content: "";
    display: table
}

.clear:after {
    clear: both
}

body,
.body {
    background: #ffffff;
    height: 100%
}

.mod-title {
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-bottom: 1px solid #ddd;
    background: #fff
}

.mod-title .ico-wechat {
    display: inline-block;
    width: 41px;
    height: 38px;
    background: url("https://s1.ax1x.com/2023/07/21/pCbJn8x.png") 0 -113px no-repeat;
    vertical-align: middle;
    margin-right: 7px
}

.mod-title .text {
    font-size: 20px;
    color: #333;
    font-weight: normal;
    vertical-align: middle
}

.mod-ct {
    width: 610px;
    padding: 0 135px;
    margin: 0 auto;
    margin-top: 15px;
    background: #fff url("https://s1.ax1x.com/2023/07/21/pCbJmP1.png") top center repeat-x;
    text-align: center;
    color: #333;
    border: 1px solid #e5e5e5;
    border-top: none
}

.mod-ct .order {
    font-size: 20px;
    padding-top: 30px
}

.mod-ct .amount {
    font-size: 48px;
    margin-top: 20px
}

.mod-ct .qr-image {
    margin-top: 30px
}

.mod-ct .qr-image img {
    width: 300px;
    height: 300px
}

.mod-ct .detail {
    padding-top: 25px
}

.mod-ct .detail .arrow .ico-arrow {
    display: inline-block;
    width: 20px;
    height: 11px;
    background: url("https://s1.ax1x.com/2023/07/21/pCbJn8x.png") -25px -100px no-repeat
}

.mod-ct .detail .detail-ct {
    display: none;
    font-size: 14px;
    text-align: right;
    line-height: 28px
}

.mod-ct .detail .detail-ct dt {
    float: left
}

.mod-ct .detail-open {
    border-top: 1px solid #e5e5e5
}

.mod-ct .detail .arrow {
    padding: 6px 34px;
    border: 1px solid #e5e5e5
}

.mod-ct .detail .arrow .ico-arrow {
    display: inline-block;
    width: 20px;
    height: 11px;
    background: url("https://s1.ax1x.com/2023/07/21/pCbJn8x.png") -25px -100px no-repeat
}

.mod-ct .detail-open .arrow .ico-arrow {
    display: inline-block;
    width: 20px;
    height: 11px;
    background: url("https://s1.ax1x.com/2023/07/21/pCbJn8x.png") 0 -100px no-repeat
}

.mod-ct .detail-open .detail-ct {
    display: block
}

.mod-ct .tip {
    margin-top: 40px;
    border-top: 1px dashed #e5e5e5;
    padding: 30px 0;
    position: relative
}

.mod-ct .tip .ico-scan {
    display: inline-block;
    width: 56px;
    height: 55px;
    background: url("https://s1.ax1x.com/2023/07/21/pCbJn8x.png") 0 0 no-repeat;
    vertical-align: middle;
    *display: inline;
    *zoom: 1
}

.mod-ct .tip .tip-text {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    margin-left: 23px;
    font-size: 16px;
    line-height: 28px;
    *display: inline;
    *zoom: 1
}

.mod-ct .tip .dec {
    display: inline-block;
    width: 22px;
    height: 45px;
    background: url("https://s1.ax1x.com/2023/07/21/pCbJn8x.png") 0 -55px no-repeat;
    position: absolute;
    top: -23px
}

.mod-ct .tip .dec-left {
    background-position: 0 -55px;
    left: -136px
}

.mod-ct .tip .dec-right {
    background-position: -25px -55px;
    right: -136px
}

.foot {
    text-align: center;
    margin: 30px auto;
    color: #888888;
    font-size: 12px;
    line-height: 20px;
    font-family: "simsun"
}

.foot .link {
    color: #0071ce
}

.open_app {}

a.btn-open-app {
    border: 1px solid #328ce5;
    padding: 10px 20px;
    color: #fff;
    background: #328ce5;
    font-size: 14px;
    cursor: pointer
}

a.btn-check {
    padding: 10px 20px;
    color: #328ce5;
    font-size: 14px;
    cursor: pointer
}

@media (max-width: 768px) {
    .mod-ct {
        width: 100%;
        padding: 0;
        border: 0
    }

    .mod-ct .tip .dec-right {
        display: none
    }

    .mod-ct .detail {
        margin-top: 30px
    }

    .mod-ct .detail .detail-ct {
        padding: 0 19px;
        margin-bottom: 19px
    }
}
</style>
<template>
    <div class="body">
        <h1 class="mod-title">
            <span class="ico-wechat"></span><span class="text">支付宝扫码支付</span>
        </h1>
        <div class="mod-ct">
            <div class="order">
            </div>
            <div class="amount">￥{{ conf.money }}</div>
            <div class="qr-image" id="qrcode">
                <img class="imgQR" :src="conf.imgBase64" alt="" />
            </div>
            <div class="open_app" style="display: none;display: flex;flex-direction: column;align-items: center">
                <a class="btn-open-app" :href="conf.url">打开支付宝APP继续付款</a>
                <a @click="checkresult()" style="margin-top: 0.5rem;color: #328ce5;">我已付款，返回查看订单</a>
            </div>
            <div class="detail" id="orderDetail">
                <dl class="detail-ct" style="display: none;">
                    <dt>购买物品</dt>
                    <dd id="productName">{{ conf.productName }}</dd>
                    <dt>商户订单号</dt>
                    <dd id="billId">{{ conf.outTradeNo }}</dd>
                    <dt>创建时间</dt>
                    <dd id="createTime">{{ conf.addTime }}</dd>
                </dl>
                <a href="javascript:void(0)" class="arrow"  @click="toggleDetail()">
                    <i class="ico-arrow"></i>
                </a>
            </div>
            <div class="tip">
                <span class="dec dec-left"></span>
                <span class="dec dec-right"></span>
                <div class="ico-scan"></div>
                <div class="tip-text">
                    <p>请使用支付宝扫一扫</p>
                    <p>扫描二维码完成支付</p>
                </div>
            </div>
            <div class="tip-text">
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { ElMessage } from 'element-plus'
import axios from 'axios';
import $ from 'jquery'
import router from '@/router';
import { isNull } from '@/utils/publicMethods';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    computed: {
        ...mapState(['QRCode'])
    },
    data() {
        return {
            conf: {
                productName: "在线充值",
                outTradeNo: sessionStorage.getItem("outTradeNo"),
                addTime: "2024-10-01 00:46:53",
                money: "10.10",
                imgBase64: "",
                url: ""
            }
        }
    }, methods: {
        getConf() {
            axios.get(baseURL + '/pay/DMF/' + this.conf.outTradeNo)
                .then(res => {
                    if (res.data.code == 200) {
                        let data = res.data.data.data
                        this.conf.imgBase64 = data.imgBase64
                        this.conf.productName = data.name;
                        this.conf.addTime = data.addTime;
                        this.conf.money = data.money;
                        this.conf.url = data.url;
                        console.log(this.conf);

                    } else {
                        ElMessage.error(res.data.msg)
                        setTimeout(() => {
                            router.push("/")
                        }, 2000);
                    }
                })
        },
        toggleDetail() {
            if ($('#orderDetail').hasClass('detail-open')) {
                $('#orderDetail .detail-ct').slideUp(500, function () {
                    $('#orderDetail').removeClass('detail-open')
                })
            } else {
                $('#orderDetail .detail-ct').slideDown(500, function () {
                    $('#orderDetail').addClass('detail-open')
                })
            }
        },
        isMobile() {
            var ua = navigator.userAgent;
            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
             isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
                isAndroid = ua.match(/(Android)\s+([\d.]+)/);
            return isIphone || isAndroid
        },
        checkresult() {
            if(isNull(this.conf.outTradeNo)){
                return;
            }
            axios.get(baseURL + '/pay/DMF/queryOrder/' + this.conf.outTradeNo)
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success(res.data.msg)
                        setTimeout(() => {
                            location.href = "/"
                        }, 2000);
                    }
                })
        }
    },
    mounted() {
        this.getConf()
        if (this.isMobile()) {
            $('.open_app').show();
        }else {
            $('.open_app').hide();
        }
        setInterval(() => {
            this.checkresult()
        }, 3000);
    }
})
</script>